var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8379 18.204L11.1135 19.491C11.0247 19.5058 10.9414 19.5438 10.8719 19.601C10.8024 19.6583 10.7492 19.7328 10.7177 19.8171L8.05436 26.9528C7.80003 27.6092 8.48611 28.2347 9.1158 27.9189L27.5755 18.689C27.7031 18.6251 27.8103 18.5269 27.8853 18.4055C27.9603 18.284 28 18.1441 28 18.0014C28 17.8587 27.9603 17.7188 27.8853 17.5974C27.8103 17.4759 27.7031 17.3777 27.5755 17.3138L9.1158 8.08395C8.48611 7.76911 7.80003 8.39469 8.05436 9.05001L10.7187 16.1857C10.7503 16.27 10.8034 16.3446 10.8729 16.4018C10.9424 16.4591 11.0258 16.497 11.1146 16.5118L18.8389 17.7989C18.8871 17.8066 18.931 17.8312 18.9626 17.8683C18.9943 17.9054 19.0117 17.9526 19.0117 18.0014C19.0117 18.0502 18.9943 18.0974 18.9626 18.1345C18.931 18.1716 18.8871 18.1963 18.8389 18.204",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.f325f7a153b80ab5fdd9f805a16d5486.svg";
export { ForwardRef as ReactComponent };